import { isValidEnrichedContext } from './EnrichedContext';
export function enrichedContextApiToEnrichedContextEntity(data) {
  if (!data) {
    throw new Error('EnrichedContext data is required');
  }
  if (!isValidEnrichedContext(data)) {
    throw new Error('Invalid enriched context data');
  }
  return data;
}
export function enrichedContextToEnrichedContextApi(data) {
  return {
    id: data.id,
    revision: data.revision,
    createdDate: data.createdDate,
    updatedDate: data.updatedDate,
    entityId: data.entityId,
    context: data.context
  };
}
//# sourceMappingURL=converters.js.map